import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Users, Radio, FileText, CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";
import { StatCard, Badge, statusTone } from "@/components/common";

export default function EducatorDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/educator/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return null;
  return (
    <div data-testid="educator-dashboard">
      <h1 className="font-heading text-3xl font-bold text-navy mb-8">Educator Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <StatCard label="Total Courses" value={d.total_courses} icon={BookOpen} testid="stat-total-courses" />
        <StatCard label="Published" value={d.published} icon={CheckCircle2} accent="bg-emerald-600" />
        <StatCard label="Pending Approval" value={d.pending} icon={Clock} accent="bg-amber" />
        <StatCard label="Students" value={d.total_students} icon={Users} accent="bg-crimson" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5 mb-10">
        <StatCard label="Test Series Created" value={d.total_tests} icon={FileText} />
        <StatCard label="Upcoming Live Classes" value={d.upcoming_classes} icon={Radio} accent="bg-navy" />
      </div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl font-bold text-navy">Your Courses</h2>
        <Link to="/educator/courses" className="text-amber font-semibold text-sm">Manage all →</Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {d.courses.map((c) => (
          <Link key={c.id} to={`/educator/courses`} className="bg-white border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all">
            <img src={c.thumbnail} alt="" className="w-full aspect-video object-cover" />
            <div className="p-4"><h3 className="font-semibold text-navy text-sm line-clamp-1">{c.title}</h3>
              <div className="flex items-center justify-between mt-2"><Badge tone={statusTone(c.status)}>{c.status}</Badge><span className="text-xs text-muted-foreground">{c.enrolled_count} students</span></div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
